// C:\Users\EYG\fynwise-website\src\app\pricing\components\pricing-cards.tsx
"use client";

import { Shield, Building, Gem, Zap } from "lucide-react";
import PricingCard from "./pricing-card";
import Spotlight from "@/components/magicui/spotlight";

interface PricingCardsProps {
  isAnnual: boolean;
}

interface Plan {
  name: string;
  icon: React.ReactNode;
  price: string;
  description: string;
  keyFeatures: string[];
  cta: string;
  popular: boolean;
  contactPage?: boolean;
}

export default function PricingCards({ isAnnual }: PricingCardsProps) {
  const plans: Plan[] = [
    {
      name: "Basic",
      icon: <Shield className="w-5 h-5 text-gray-300" />,
      price: "0",
      description: "Start your trading journey today",
      keyFeatures: [
        "AI Market Analysis",
        "Basic Backtesting Tools",
        "Educational Resources",
        "Community Access"
      ],
      cta: "Start Free",
      popular: false
    },
    {
      name: "Pro",
      icon: <Zap className="w-5 h-5 text-black" />,
      price: isAnnual ? "79" : "99",
      description: "Advanced tools for serious traders",
      keyFeatures: [
        "Advanced AI Strategies",
        "Real-time Trading Signals",
        "Multiple Asset Analysis",
        "Priority Support"
      ],
      cta: "Get Pro",
      popular: true
    },
    {
      name: "Premium",
      icon: <Gem className="w-5 h-5 text-gray-300" />,
      price: isAnnual ? "299" : "349",
      description: "Professional-grade trading suite",
      keyFeatures: [
        "Custom Strategy Development",
        "Advanced Portfolio Management",
        "Risk Analytics Suite",
        "Dedicated Account Manager"
      ],
      cta: "Go Premium",
      popular: false
    },
    {
      name: "Enterprise",
      icon: <Building className="w-5 h-5 text-gray-300" />,
      price: "Custom",
      description: "Full-scale institutional solution",
      keyFeatures: [
        "White-label Integration",
        "Custom Data Infrastructure",
        "Enterprise API Access",
        "Full Compliance Suite"
      ],
      cta: "Contact Us",
      popular: false,
      contactPage: true
    }
  ];

  return (
    <div className="container mx-auto px-4 my-4">
      <Spotlight className="mx-auto grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {plans.map((plan) => (
          <div key={plan.name} className="h-full">
            <PricingCard
              plan={plan}
              isAnnual={isAnnual}
            />
          </div>
        ))}
      </Spotlight>
    </div>
  );
}